// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.4
// source: bridge/tx.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Chain } from "./models/chain";
import { EpochBridgeAddress, EpochChainSignatures, TSSInfo } from "./models/epoch";
import { Party } from "./models/party";
import { Referral, ReferralRewards } from "./models/referrals";
import { Token, TokenInfo, TokenMetadata } from "./models/token";
import { Transaction } from "./models/transaction";

export const protobufPackage = "core.bridge";

/** this line is used by starport scaffolding # proto/tx/message */
export interface MsgSubmitTransactions {
  submitter: string;
  transactions: Transaction[];
}

export interface MsgRemoveTransaction {
  creator: string;
  depositChainId: string;
  depositTxHash: string;
  depositTxIndex: string;
}

export interface MsgRemoveTransactionResponse {
}

export interface MsgUpdateTransaction {
  submitter: string;
  transaction?: Transaction | undefined;
}

export interface MsgUpdateTransactionResponse {
}

export interface MsgSubmitTransactionsResponse {
}

export interface MsgInsertToken {
  creator: string;
  token?: Token | undefined;
}

export interface MsgInsertTokenResponse {
}

export interface MsgUpdateToken {
  creator: string;
  tokenId: string;
  metadata?: TokenMetadata | undefined;
}

export interface MsgUpdateTokenResponse {
}

export interface MsgDeleteToken {
  creator: string;
  tokenId: string;
}

export interface MsgDeleteTokenResponse {
}

export interface MsgInsertChain {
  creator: string;
  chain?: Chain | undefined;
}

export interface MsgInsertChainResponse {
}

export interface MsgDeleteChain {
  creator: string;
  chainId: string;
}

export interface MsgDeleteChainResponse {
}

export interface MsgAddTokenInfo {
  creator: string;
  info?: TokenInfo | undefined;
}

export interface MsgAddTokenInfoResponse {
}

export interface MsgRemoveTokenInfo {
  creator: string;
  tokenId: string;
  chainId: string;
}

export interface MsgRemoveTokenInfoResponse {
}

export interface MsgSetParties {
  creator: string;
  parties: Party[];
}

export interface MsgSetPartiesResponse {
}

export interface MsgSetTssThreshold {
  creator: string;
  threshold: number;
}

export interface MsgSetTssThresholdResponse {
}

export interface MsgSetReferral {
  creator: string;
  referral?: Referral | undefined;
}

export interface MsgSetReferralResponse {
}

export interface MsgRemoveReferral {
  creator: string;
  id: number;
}

export interface MsgRemoveReferralResponse {
}

export interface MsgSetReferralRewards {
  creator: string;
  rewards?: ReferralRewards | undefined;
}

export interface MsgSetReferralRewardsResponse {
}

export interface MsgRemoveReferralRewards {
  creator: string;
  referrerId: number;
  tokenId: string;
}

export interface MsgRemoveReferralRewardsResponse {
}

export interface MsgAddTxToStopList {
  transaction?: Transaction | undefined;
  creator: string;
}

export interface MsgAddTxToStopListResponse {
}

export interface MsgRemoveTxFromStopList {
  chainId: string;
  txHash: string;
  txNonce: string;
  creator: string;
}

export interface MsgRemoveTxFromStopListResponse {
}

export interface MsgStartEpoch {
  creator: string;
  epochId: number;
  info: TSSInfo[];
  tssThreshold: number;
  startTime: string;
}

export interface MsgStartEpochResponse {
}

export interface MsgSetEpochSignature {
  creator: string;
  epochId: number;
  epochChainSignatures: EpochChainSignatures[];
  addresses: EpochBridgeAddress[];
}

export interface MsgSetEpochSignatureResponse {
}

export interface MsgSetEpochPubKey {
  creator: string;
  pubkey: string;
  epochId: number;
}

export interface MsgSetEpochPubKeyResponse {
}

function createBaseMsgSubmitTransactions(): MsgSubmitTransactions {
  return { submitter: "", transactions: [] };
}

export const MsgSubmitTransactions: MessageFns<MsgSubmitTransactions> = {
  encode(message: MsgSubmitTransactions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.submitter !== "") {
      writer.uint32(10).string(message.submitter);
    }
    for (const v of message.transactions) {
      Transaction.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSubmitTransactions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSubmitTransactions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.submitter = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.transactions.push(Transaction.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSubmitTransactions {
    return {
      submitter: isSet(object.submitter) ? globalThis.String(object.submitter) : "",
      transactions: globalThis.Array.isArray(object?.transactions)
        ? object.transactions.map((e: any) => Transaction.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MsgSubmitTransactions): unknown {
    const obj: any = {};
    if (message.submitter !== "") {
      obj.submitter = message.submitter;
    }
    if (message.transactions?.length) {
      obj.transactions = message.transactions.map((e) => Transaction.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSubmitTransactions>, I>>(base?: I): MsgSubmitTransactions {
    return MsgSubmitTransactions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSubmitTransactions>, I>>(object: I): MsgSubmitTransactions {
    const message = createBaseMsgSubmitTransactions();
    message.submitter = object.submitter ?? "";
    message.transactions = object.transactions?.map((e) => Transaction.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMsgRemoveTransaction(): MsgRemoveTransaction {
  return { creator: "", depositChainId: "", depositTxHash: "", depositTxIndex: "0" };
}

export const MsgRemoveTransaction: MessageFns<MsgRemoveTransaction> = {
  encode(message: MsgRemoveTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.depositChainId !== "") {
      writer.uint32(18).string(message.depositChainId);
    }
    if (message.depositTxHash !== "") {
      writer.uint32(26).string(message.depositTxHash);
    }
    if (message.depositTxIndex !== "0") {
      writer.uint32(32).uint64(message.depositTxIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.depositChainId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.depositTxHash = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.depositTxIndex = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgRemoveTransaction {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      depositChainId: isSet(object.depositChainId)
        ? globalThis.String(object.depositChainId)
        : isSet(object.deposit_chain_id)
        ? globalThis.String(object.deposit_chain_id)
        : "",
      depositTxHash: isSet(object.depositTxHash)
        ? globalThis.String(object.depositTxHash)
        : isSet(object.deposit_tx_hash)
        ? globalThis.String(object.deposit_tx_hash)
        : "",
      depositTxIndex: isSet(object.depositTxIndex)
        ? globalThis.String(object.depositTxIndex)
        : isSet(object.deposit_tx_index)
        ? globalThis.String(object.deposit_tx_index)
        : "0",
    };
  },

  toJSON(message: MsgRemoveTransaction): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.depositChainId !== "") {
      obj.depositChainId = message.depositChainId;
    }
    if (message.depositTxHash !== "") {
      obj.depositTxHash = message.depositTxHash;
    }
    if (message.depositTxIndex !== "0") {
      obj.depositTxIndex = message.depositTxIndex;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveTransaction>, I>>(base?: I): MsgRemoveTransaction {
    return MsgRemoveTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveTransaction>, I>>(object: I): MsgRemoveTransaction {
    const message = createBaseMsgRemoveTransaction();
    message.creator = object.creator ?? "";
    message.depositChainId = object.depositChainId ?? "";
    message.depositTxHash = object.depositTxHash ?? "";
    message.depositTxIndex = object.depositTxIndex ?? "0";
    return message;
  },
};

function createBaseMsgRemoveTransactionResponse(): MsgRemoveTransactionResponse {
  return {};
}

export const MsgRemoveTransactionResponse: MessageFns<MsgRemoveTransactionResponse> = {
  encode(_: MsgRemoveTransactionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveTransactionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveTransactionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgRemoveTransactionResponse {
    return {};
  },

  toJSON(_: MsgRemoveTransactionResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveTransactionResponse>, I>>(base?: I): MsgRemoveTransactionResponse {
    return MsgRemoveTransactionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveTransactionResponse>, I>>(_: I): MsgRemoveTransactionResponse {
    const message = createBaseMsgRemoveTransactionResponse();
    return message;
  },
};

function createBaseMsgUpdateTransaction(): MsgUpdateTransaction {
  return { submitter: "", transaction: undefined };
}

export const MsgUpdateTransaction: MessageFns<MsgUpdateTransaction> = {
  encode(message: MsgUpdateTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.submitter !== "") {
      writer.uint32(10).string(message.submitter);
    }
    if (message.transaction !== undefined) {
      Transaction.encode(message.transaction, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.submitter = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.transaction = Transaction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgUpdateTransaction {
    return {
      submitter: isSet(object.submitter) ? globalThis.String(object.submitter) : "",
      transaction: isSet(object.transaction) ? Transaction.fromJSON(object.transaction) : undefined,
    };
  },

  toJSON(message: MsgUpdateTransaction): unknown {
    const obj: any = {};
    if (message.submitter !== "") {
      obj.submitter = message.submitter;
    }
    if (message.transaction !== undefined) {
      obj.transaction = Transaction.toJSON(message.transaction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgUpdateTransaction>, I>>(base?: I): MsgUpdateTransaction {
    return MsgUpdateTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateTransaction>, I>>(object: I): MsgUpdateTransaction {
    const message = createBaseMsgUpdateTransaction();
    message.submitter = object.submitter ?? "";
    message.transaction = (object.transaction !== undefined && object.transaction !== null)
      ? Transaction.fromPartial(object.transaction)
      : undefined;
    return message;
  },
};

function createBaseMsgUpdateTransactionResponse(): MsgUpdateTransactionResponse {
  return {};
}

export const MsgUpdateTransactionResponse: MessageFns<MsgUpdateTransactionResponse> = {
  encode(_: MsgUpdateTransactionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateTransactionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateTransactionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgUpdateTransactionResponse {
    return {};
  },

  toJSON(_: MsgUpdateTransactionResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgUpdateTransactionResponse>, I>>(base?: I): MsgUpdateTransactionResponse {
    return MsgUpdateTransactionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateTransactionResponse>, I>>(_: I): MsgUpdateTransactionResponse {
    const message = createBaseMsgUpdateTransactionResponse();
    return message;
  },
};

function createBaseMsgSubmitTransactionsResponse(): MsgSubmitTransactionsResponse {
  return {};
}

export const MsgSubmitTransactionsResponse: MessageFns<MsgSubmitTransactionsResponse> = {
  encode(_: MsgSubmitTransactionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSubmitTransactionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSubmitTransactionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSubmitTransactionsResponse {
    return {};
  },

  toJSON(_: MsgSubmitTransactionsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSubmitTransactionsResponse>, I>>(base?: I): MsgSubmitTransactionsResponse {
    return MsgSubmitTransactionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSubmitTransactionsResponse>, I>>(_: I): MsgSubmitTransactionsResponse {
    const message = createBaseMsgSubmitTransactionsResponse();
    return message;
  },
};

function createBaseMsgInsertToken(): MsgInsertToken {
  return { creator: "", token: undefined };
}

export const MsgInsertToken: MessageFns<MsgInsertToken> = {
  encode(message: MsgInsertToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.token !== undefined) {
      Token.encode(message.token, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgInsertToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInsertToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.token = Token.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgInsertToken {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      token: isSet(object.token) ? Token.fromJSON(object.token) : undefined,
    };
  },

  toJSON(message: MsgInsertToken): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.token !== undefined) {
      obj.token = Token.toJSON(message.token);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgInsertToken>, I>>(base?: I): MsgInsertToken {
    return MsgInsertToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgInsertToken>, I>>(object: I): MsgInsertToken {
    const message = createBaseMsgInsertToken();
    message.creator = object.creator ?? "";
    message.token = (object.token !== undefined && object.token !== null) ? Token.fromPartial(object.token) : undefined;
    return message;
  },
};

function createBaseMsgInsertTokenResponse(): MsgInsertTokenResponse {
  return {};
}

export const MsgInsertTokenResponse: MessageFns<MsgInsertTokenResponse> = {
  encode(_: MsgInsertTokenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgInsertTokenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInsertTokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgInsertTokenResponse {
    return {};
  },

  toJSON(_: MsgInsertTokenResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgInsertTokenResponse>, I>>(base?: I): MsgInsertTokenResponse {
    return MsgInsertTokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgInsertTokenResponse>, I>>(_: I): MsgInsertTokenResponse {
    const message = createBaseMsgInsertTokenResponse();
    return message;
  },
};

function createBaseMsgUpdateToken(): MsgUpdateToken {
  return { creator: "", tokenId: "0", metadata: undefined };
}

export const MsgUpdateToken: MessageFns<MsgUpdateToken> = {
  encode(message: MsgUpdateToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.tokenId !== "0") {
      writer.uint32(16).uint64(message.tokenId);
    }
    if (message.metadata !== undefined) {
      TokenMetadata.encode(message.metadata, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tokenId = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata = TokenMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgUpdateToken {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
        ? globalThis.String(object.token_id)
        : "0",
      metadata: isSet(object.metadata) ? TokenMetadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: MsgUpdateToken): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.tokenId !== "0") {
      obj.tokenId = message.tokenId;
    }
    if (message.metadata !== undefined) {
      obj.metadata = TokenMetadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgUpdateToken>, I>>(base?: I): MsgUpdateToken {
    return MsgUpdateToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateToken>, I>>(object: I): MsgUpdateToken {
    const message = createBaseMsgUpdateToken();
    message.creator = object.creator ?? "";
    message.tokenId = object.tokenId ?? "0";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? TokenMetadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseMsgUpdateTokenResponse(): MsgUpdateTokenResponse {
  return {};
}

export const MsgUpdateTokenResponse: MessageFns<MsgUpdateTokenResponse> = {
  encode(_: MsgUpdateTokenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateTokenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgUpdateTokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgUpdateTokenResponse {
    return {};
  },

  toJSON(_: MsgUpdateTokenResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgUpdateTokenResponse>, I>>(base?: I): MsgUpdateTokenResponse {
    return MsgUpdateTokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgUpdateTokenResponse>, I>>(_: I): MsgUpdateTokenResponse {
    const message = createBaseMsgUpdateTokenResponse();
    return message;
  },
};

function createBaseMsgDeleteToken(): MsgDeleteToken {
  return { creator: "", tokenId: "0" };
}

export const MsgDeleteToken: MessageFns<MsgDeleteToken> = {
  encode(message: MsgDeleteToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.tokenId !== "0") {
      writer.uint32(16).uint64(message.tokenId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgDeleteToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeleteToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tokenId = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgDeleteToken {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
        ? globalThis.String(object.token_id)
        : "0",
    };
  },

  toJSON(message: MsgDeleteToken): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.tokenId !== "0") {
      obj.tokenId = message.tokenId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgDeleteToken>, I>>(base?: I): MsgDeleteToken {
    return MsgDeleteToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgDeleteToken>, I>>(object: I): MsgDeleteToken {
    const message = createBaseMsgDeleteToken();
    message.creator = object.creator ?? "";
    message.tokenId = object.tokenId ?? "0";
    return message;
  },
};

function createBaseMsgDeleteTokenResponse(): MsgDeleteTokenResponse {
  return {};
}

export const MsgDeleteTokenResponse: MessageFns<MsgDeleteTokenResponse> = {
  encode(_: MsgDeleteTokenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgDeleteTokenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeleteTokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgDeleteTokenResponse {
    return {};
  },

  toJSON(_: MsgDeleteTokenResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgDeleteTokenResponse>, I>>(base?: I): MsgDeleteTokenResponse {
    return MsgDeleteTokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgDeleteTokenResponse>, I>>(_: I): MsgDeleteTokenResponse {
    const message = createBaseMsgDeleteTokenResponse();
    return message;
  },
};

function createBaseMsgInsertChain(): MsgInsertChain {
  return { creator: "", chain: undefined };
}

export const MsgInsertChain: MessageFns<MsgInsertChain> = {
  encode(message: MsgInsertChain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.chain !== undefined) {
      Chain.encode(message.chain, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgInsertChain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInsertChain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chain = Chain.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgInsertChain {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      chain: isSet(object.chain) ? Chain.fromJSON(object.chain) : undefined,
    };
  },

  toJSON(message: MsgInsertChain): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.chain !== undefined) {
      obj.chain = Chain.toJSON(message.chain);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgInsertChain>, I>>(base?: I): MsgInsertChain {
    return MsgInsertChain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgInsertChain>, I>>(object: I): MsgInsertChain {
    const message = createBaseMsgInsertChain();
    message.creator = object.creator ?? "";
    message.chain = (object.chain !== undefined && object.chain !== null) ? Chain.fromPartial(object.chain) : undefined;
    return message;
  },
};

function createBaseMsgInsertChainResponse(): MsgInsertChainResponse {
  return {};
}

export const MsgInsertChainResponse: MessageFns<MsgInsertChainResponse> = {
  encode(_: MsgInsertChainResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgInsertChainResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgInsertChainResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgInsertChainResponse {
    return {};
  },

  toJSON(_: MsgInsertChainResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgInsertChainResponse>, I>>(base?: I): MsgInsertChainResponse {
    return MsgInsertChainResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgInsertChainResponse>, I>>(_: I): MsgInsertChainResponse {
    const message = createBaseMsgInsertChainResponse();
    return message;
  },
};

function createBaseMsgDeleteChain(): MsgDeleteChain {
  return { creator: "", chainId: "" };
}

export const MsgDeleteChain: MessageFns<MsgDeleteChain> = {
  encode(message: MsgDeleteChain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.chainId !== "") {
      writer.uint32(18).string(message.chainId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgDeleteChain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeleteChain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chainId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgDeleteChain {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      chainId: isSet(object.chainId)
        ? globalThis.String(object.chainId)
        : isSet(object.chain_id)
        ? globalThis.String(object.chain_id)
        : "",
    };
  },

  toJSON(message: MsgDeleteChain): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.chainId !== "") {
      obj.chainId = message.chainId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgDeleteChain>, I>>(base?: I): MsgDeleteChain {
    return MsgDeleteChain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgDeleteChain>, I>>(object: I): MsgDeleteChain {
    const message = createBaseMsgDeleteChain();
    message.creator = object.creator ?? "";
    message.chainId = object.chainId ?? "";
    return message;
  },
};

function createBaseMsgDeleteChainResponse(): MsgDeleteChainResponse {
  return {};
}

export const MsgDeleteChainResponse: MessageFns<MsgDeleteChainResponse> = {
  encode(_: MsgDeleteChainResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgDeleteChainResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeleteChainResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgDeleteChainResponse {
    return {};
  },

  toJSON(_: MsgDeleteChainResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgDeleteChainResponse>, I>>(base?: I): MsgDeleteChainResponse {
    return MsgDeleteChainResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgDeleteChainResponse>, I>>(_: I): MsgDeleteChainResponse {
    const message = createBaseMsgDeleteChainResponse();
    return message;
  },
};

function createBaseMsgAddTokenInfo(): MsgAddTokenInfo {
  return { creator: "", info: undefined };
}

export const MsgAddTokenInfo: MessageFns<MsgAddTokenInfo> = {
  encode(message: MsgAddTokenInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.info !== undefined) {
      TokenInfo.encode(message.info, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgAddTokenInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddTokenInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info = TokenInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgAddTokenInfo {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      info: isSet(object.info) ? TokenInfo.fromJSON(object.info) : undefined,
    };
  },

  toJSON(message: MsgAddTokenInfo): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.info !== undefined) {
      obj.info = TokenInfo.toJSON(message.info);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgAddTokenInfo>, I>>(base?: I): MsgAddTokenInfo {
    return MsgAddTokenInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgAddTokenInfo>, I>>(object: I): MsgAddTokenInfo {
    const message = createBaseMsgAddTokenInfo();
    message.creator = object.creator ?? "";
    message.info = (object.info !== undefined && object.info !== null) ? TokenInfo.fromPartial(object.info) : undefined;
    return message;
  },
};

function createBaseMsgAddTokenInfoResponse(): MsgAddTokenInfoResponse {
  return {};
}

export const MsgAddTokenInfoResponse: MessageFns<MsgAddTokenInfoResponse> = {
  encode(_: MsgAddTokenInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgAddTokenInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddTokenInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgAddTokenInfoResponse {
    return {};
  },

  toJSON(_: MsgAddTokenInfoResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgAddTokenInfoResponse>, I>>(base?: I): MsgAddTokenInfoResponse {
    return MsgAddTokenInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgAddTokenInfoResponse>, I>>(_: I): MsgAddTokenInfoResponse {
    const message = createBaseMsgAddTokenInfoResponse();
    return message;
  },
};

function createBaseMsgRemoveTokenInfo(): MsgRemoveTokenInfo {
  return { creator: "", tokenId: "0", chainId: "" };
}

export const MsgRemoveTokenInfo: MessageFns<MsgRemoveTokenInfo> = {
  encode(message: MsgRemoveTokenInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.tokenId !== "0") {
      writer.uint32(16).uint64(message.tokenId);
    }
    if (message.chainId !== "") {
      writer.uint32(26).string(message.chainId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveTokenInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveTokenInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tokenId = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.chainId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgRemoveTokenInfo {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
        ? globalThis.String(object.token_id)
        : "0",
      chainId: isSet(object.chainId)
        ? globalThis.String(object.chainId)
        : isSet(object.chain_id)
        ? globalThis.String(object.chain_id)
        : "",
    };
  },

  toJSON(message: MsgRemoveTokenInfo): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.tokenId !== "0") {
      obj.tokenId = message.tokenId;
    }
    if (message.chainId !== "") {
      obj.chainId = message.chainId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveTokenInfo>, I>>(base?: I): MsgRemoveTokenInfo {
    return MsgRemoveTokenInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveTokenInfo>, I>>(object: I): MsgRemoveTokenInfo {
    const message = createBaseMsgRemoveTokenInfo();
    message.creator = object.creator ?? "";
    message.tokenId = object.tokenId ?? "0";
    message.chainId = object.chainId ?? "";
    return message;
  },
};

function createBaseMsgRemoveTokenInfoResponse(): MsgRemoveTokenInfoResponse {
  return {};
}

export const MsgRemoveTokenInfoResponse: MessageFns<MsgRemoveTokenInfoResponse> = {
  encode(_: MsgRemoveTokenInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveTokenInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveTokenInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgRemoveTokenInfoResponse {
    return {};
  },

  toJSON(_: MsgRemoveTokenInfoResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveTokenInfoResponse>, I>>(base?: I): MsgRemoveTokenInfoResponse {
    return MsgRemoveTokenInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveTokenInfoResponse>, I>>(_: I): MsgRemoveTokenInfoResponse {
    const message = createBaseMsgRemoveTokenInfoResponse();
    return message;
  },
};

function createBaseMsgSetParties(): MsgSetParties {
  return { creator: "", parties: [] };
}

export const MsgSetParties: MessageFns<MsgSetParties> = {
  encode(message: MsgSetParties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    for (const v of message.parties) {
      Party.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetParties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetParties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.parties.push(Party.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSetParties {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      parties: globalThis.Array.isArray(object?.parties) ? object.parties.map((e: any) => Party.fromJSON(e)) : [],
    };
  },

  toJSON(message: MsgSetParties): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.parties?.length) {
      obj.parties = message.parties.map((e) => Party.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetParties>, I>>(base?: I): MsgSetParties {
    return MsgSetParties.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetParties>, I>>(object: I): MsgSetParties {
    const message = createBaseMsgSetParties();
    message.creator = object.creator ?? "";
    message.parties = object.parties?.map((e) => Party.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMsgSetPartiesResponse(): MsgSetPartiesResponse {
  return {};
}

export const MsgSetPartiesResponse: MessageFns<MsgSetPartiesResponse> = {
  encode(_: MsgSetPartiesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetPartiesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetPartiesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSetPartiesResponse {
    return {};
  },

  toJSON(_: MsgSetPartiesResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetPartiesResponse>, I>>(base?: I): MsgSetPartiesResponse {
    return MsgSetPartiesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetPartiesResponse>, I>>(_: I): MsgSetPartiesResponse {
    const message = createBaseMsgSetPartiesResponse();
    return message;
  },
};

function createBaseMsgSetTssThreshold(): MsgSetTssThreshold {
  return { creator: "", threshold: 0 };
}

export const MsgSetTssThreshold: MessageFns<MsgSetTssThreshold> = {
  encode(message: MsgSetTssThreshold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.threshold !== 0) {
      writer.uint32(16).uint32(message.threshold);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetTssThreshold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetTssThreshold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.threshold = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSetTssThreshold {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      threshold: isSet(object.threshold) ? globalThis.Number(object.threshold) : 0,
    };
  },

  toJSON(message: MsgSetTssThreshold): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.threshold !== 0) {
      obj.threshold = Math.round(message.threshold);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetTssThreshold>, I>>(base?: I): MsgSetTssThreshold {
    return MsgSetTssThreshold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetTssThreshold>, I>>(object: I): MsgSetTssThreshold {
    const message = createBaseMsgSetTssThreshold();
    message.creator = object.creator ?? "";
    message.threshold = object.threshold ?? 0;
    return message;
  },
};

function createBaseMsgSetTssThresholdResponse(): MsgSetTssThresholdResponse {
  return {};
}

export const MsgSetTssThresholdResponse: MessageFns<MsgSetTssThresholdResponse> = {
  encode(_: MsgSetTssThresholdResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetTssThresholdResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetTssThresholdResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSetTssThresholdResponse {
    return {};
  },

  toJSON(_: MsgSetTssThresholdResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetTssThresholdResponse>, I>>(base?: I): MsgSetTssThresholdResponse {
    return MsgSetTssThresholdResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetTssThresholdResponse>, I>>(_: I): MsgSetTssThresholdResponse {
    const message = createBaseMsgSetTssThresholdResponse();
    return message;
  },
};

function createBaseMsgSetReferral(): MsgSetReferral {
  return { creator: "", referral: undefined };
}

export const MsgSetReferral: MessageFns<MsgSetReferral> = {
  encode(message: MsgSetReferral, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.referral !== undefined) {
      Referral.encode(message.referral, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetReferral {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetReferral();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.referral = Referral.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSetReferral {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      referral: isSet(object.referral) ? Referral.fromJSON(object.referral) : undefined,
    };
  },

  toJSON(message: MsgSetReferral): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.referral !== undefined) {
      obj.referral = Referral.toJSON(message.referral);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetReferral>, I>>(base?: I): MsgSetReferral {
    return MsgSetReferral.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetReferral>, I>>(object: I): MsgSetReferral {
    const message = createBaseMsgSetReferral();
    message.creator = object.creator ?? "";
    message.referral = (object.referral !== undefined && object.referral !== null)
      ? Referral.fromPartial(object.referral)
      : undefined;
    return message;
  },
};

function createBaseMsgSetReferralResponse(): MsgSetReferralResponse {
  return {};
}

export const MsgSetReferralResponse: MessageFns<MsgSetReferralResponse> = {
  encode(_: MsgSetReferralResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetReferralResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetReferralResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSetReferralResponse {
    return {};
  },

  toJSON(_: MsgSetReferralResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetReferralResponse>, I>>(base?: I): MsgSetReferralResponse {
    return MsgSetReferralResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetReferralResponse>, I>>(_: I): MsgSetReferralResponse {
    const message = createBaseMsgSetReferralResponse();
    return message;
  },
};

function createBaseMsgRemoveReferral(): MsgRemoveReferral {
  return { creator: "", id: 0 };
}

export const MsgRemoveReferral: MessageFns<MsgRemoveReferral> = {
  encode(message: MsgRemoveReferral, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint32(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveReferral {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveReferral();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgRemoveReferral {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
    };
  },

  toJSON(message: MsgRemoveReferral): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveReferral>, I>>(base?: I): MsgRemoveReferral {
    return MsgRemoveReferral.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveReferral>, I>>(object: I): MsgRemoveReferral {
    const message = createBaseMsgRemoveReferral();
    message.creator = object.creator ?? "";
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseMsgRemoveReferralResponse(): MsgRemoveReferralResponse {
  return {};
}

export const MsgRemoveReferralResponse: MessageFns<MsgRemoveReferralResponse> = {
  encode(_: MsgRemoveReferralResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveReferralResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveReferralResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgRemoveReferralResponse {
    return {};
  },

  toJSON(_: MsgRemoveReferralResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveReferralResponse>, I>>(base?: I): MsgRemoveReferralResponse {
    return MsgRemoveReferralResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveReferralResponse>, I>>(_: I): MsgRemoveReferralResponse {
    const message = createBaseMsgRemoveReferralResponse();
    return message;
  },
};

function createBaseMsgSetReferralRewards(): MsgSetReferralRewards {
  return { creator: "", rewards: undefined };
}

export const MsgSetReferralRewards: MessageFns<MsgSetReferralRewards> = {
  encode(message: MsgSetReferralRewards, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.rewards !== undefined) {
      ReferralRewards.encode(message.rewards, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetReferralRewards {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetReferralRewards();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.rewards = ReferralRewards.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSetReferralRewards {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      rewards: isSet(object.rewards) ? ReferralRewards.fromJSON(object.rewards) : undefined,
    };
  },

  toJSON(message: MsgSetReferralRewards): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.rewards !== undefined) {
      obj.rewards = ReferralRewards.toJSON(message.rewards);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetReferralRewards>, I>>(base?: I): MsgSetReferralRewards {
    return MsgSetReferralRewards.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetReferralRewards>, I>>(object: I): MsgSetReferralRewards {
    const message = createBaseMsgSetReferralRewards();
    message.creator = object.creator ?? "";
    message.rewards = (object.rewards !== undefined && object.rewards !== null)
      ? ReferralRewards.fromPartial(object.rewards)
      : undefined;
    return message;
  },
};

function createBaseMsgSetReferralRewardsResponse(): MsgSetReferralRewardsResponse {
  return {};
}

export const MsgSetReferralRewardsResponse: MessageFns<MsgSetReferralRewardsResponse> = {
  encode(_: MsgSetReferralRewardsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetReferralRewardsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetReferralRewardsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSetReferralRewardsResponse {
    return {};
  },

  toJSON(_: MsgSetReferralRewardsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetReferralRewardsResponse>, I>>(base?: I): MsgSetReferralRewardsResponse {
    return MsgSetReferralRewardsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetReferralRewardsResponse>, I>>(_: I): MsgSetReferralRewardsResponse {
    const message = createBaseMsgSetReferralRewardsResponse();
    return message;
  },
};

function createBaseMsgRemoveReferralRewards(): MsgRemoveReferralRewards {
  return { creator: "", referrerId: 0, tokenId: "0" };
}

export const MsgRemoveReferralRewards: MessageFns<MsgRemoveReferralRewards> = {
  encode(message: MsgRemoveReferralRewards, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.referrerId !== 0) {
      writer.uint32(16).uint32(message.referrerId);
    }
    if (message.tokenId !== "0") {
      writer.uint32(24).uint64(message.tokenId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveReferralRewards {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveReferralRewards();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.referrerId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.tokenId = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgRemoveReferralRewards {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      referrerId: isSet(object.referrerId)
        ? globalThis.Number(object.referrerId)
        : isSet(object.referrer_id)
        ? globalThis.Number(object.referrer_id)
        : 0,
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
        ? globalThis.String(object.token_id)
        : "0",
    };
  },

  toJSON(message: MsgRemoveReferralRewards): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.referrerId !== 0) {
      obj.referrerId = Math.round(message.referrerId);
    }
    if (message.tokenId !== "0") {
      obj.tokenId = message.tokenId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveReferralRewards>, I>>(base?: I): MsgRemoveReferralRewards {
    return MsgRemoveReferralRewards.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveReferralRewards>, I>>(object: I): MsgRemoveReferralRewards {
    const message = createBaseMsgRemoveReferralRewards();
    message.creator = object.creator ?? "";
    message.referrerId = object.referrerId ?? 0;
    message.tokenId = object.tokenId ?? "0";
    return message;
  },
};

function createBaseMsgRemoveReferralRewardsResponse(): MsgRemoveReferralRewardsResponse {
  return {};
}

export const MsgRemoveReferralRewardsResponse: MessageFns<MsgRemoveReferralRewardsResponse> = {
  encode(_: MsgRemoveReferralRewardsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveReferralRewardsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveReferralRewardsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgRemoveReferralRewardsResponse {
    return {};
  },

  toJSON(_: MsgRemoveReferralRewardsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveReferralRewardsResponse>, I>>(
    base?: I,
  ): MsgRemoveReferralRewardsResponse {
    return MsgRemoveReferralRewardsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveReferralRewardsResponse>, I>>(
    _: I,
  ): MsgRemoveReferralRewardsResponse {
    const message = createBaseMsgRemoveReferralRewardsResponse();
    return message;
  },
};

function createBaseMsgAddTxToStopList(): MsgAddTxToStopList {
  return { transaction: undefined, creator: "" };
}

export const MsgAddTxToStopList: MessageFns<MsgAddTxToStopList> = {
  encode(message: MsgAddTxToStopList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.transaction !== undefined) {
      Transaction.encode(message.transaction, writer.uint32(10).fork()).join();
    }
    if (message.creator !== "") {
      writer.uint32(18).string(message.creator);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgAddTxToStopList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddTxToStopList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.transaction = Transaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgAddTxToStopList {
    return {
      transaction: isSet(object.transaction) ? Transaction.fromJSON(object.transaction) : undefined,
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
    };
  },

  toJSON(message: MsgAddTxToStopList): unknown {
    const obj: any = {};
    if (message.transaction !== undefined) {
      obj.transaction = Transaction.toJSON(message.transaction);
    }
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgAddTxToStopList>, I>>(base?: I): MsgAddTxToStopList {
    return MsgAddTxToStopList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgAddTxToStopList>, I>>(object: I): MsgAddTxToStopList {
    const message = createBaseMsgAddTxToStopList();
    message.transaction = (object.transaction !== undefined && object.transaction !== null)
      ? Transaction.fromPartial(object.transaction)
      : undefined;
    message.creator = object.creator ?? "";
    return message;
  },
};

function createBaseMsgAddTxToStopListResponse(): MsgAddTxToStopListResponse {
  return {};
}

export const MsgAddTxToStopListResponse: MessageFns<MsgAddTxToStopListResponse> = {
  encode(_: MsgAddTxToStopListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgAddTxToStopListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgAddTxToStopListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgAddTxToStopListResponse {
    return {};
  },

  toJSON(_: MsgAddTxToStopListResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgAddTxToStopListResponse>, I>>(base?: I): MsgAddTxToStopListResponse {
    return MsgAddTxToStopListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgAddTxToStopListResponse>, I>>(_: I): MsgAddTxToStopListResponse {
    const message = createBaseMsgAddTxToStopListResponse();
    return message;
  },
};

function createBaseMsgRemoveTxFromStopList(): MsgRemoveTxFromStopList {
  return { chainId: "", txHash: "", txNonce: "0", creator: "" };
}

export const MsgRemoveTxFromStopList: MessageFns<MsgRemoveTxFromStopList> = {
  encode(message: MsgRemoveTxFromStopList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chainId !== "") {
      writer.uint32(10).string(message.chainId);
    }
    if (message.txHash !== "") {
      writer.uint32(18).string(message.txHash);
    }
    if (message.txNonce !== "0") {
      writer.uint32(24).uint64(message.txNonce);
    }
    if (message.creator !== "") {
      writer.uint32(34).string(message.creator);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveTxFromStopList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveTxFromStopList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chainId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.txHash = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.txNonce = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgRemoveTxFromStopList {
    return {
      chainId: isSet(object.chainId)
        ? globalThis.String(object.chainId)
        : isSet(object.chain_id)
        ? globalThis.String(object.chain_id)
        : "",
      txHash: isSet(object.txHash)
        ? globalThis.String(object.txHash)
        : isSet(object.tx_hash)
        ? globalThis.String(object.tx_hash)
        : "",
      txNonce: isSet(object.txNonce)
        ? globalThis.String(object.txNonce)
        : isSet(object.tx_nonce)
        ? globalThis.String(object.tx_nonce)
        : "0",
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
    };
  },

  toJSON(message: MsgRemoveTxFromStopList): unknown {
    const obj: any = {};
    if (message.chainId !== "") {
      obj.chainId = message.chainId;
    }
    if (message.txHash !== "") {
      obj.txHash = message.txHash;
    }
    if (message.txNonce !== "0") {
      obj.txNonce = message.txNonce;
    }
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveTxFromStopList>, I>>(base?: I): MsgRemoveTxFromStopList {
    return MsgRemoveTxFromStopList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveTxFromStopList>, I>>(object: I): MsgRemoveTxFromStopList {
    const message = createBaseMsgRemoveTxFromStopList();
    message.chainId = object.chainId ?? "";
    message.txHash = object.txHash ?? "";
    message.txNonce = object.txNonce ?? "0";
    message.creator = object.creator ?? "";
    return message;
  },
};

function createBaseMsgRemoveTxFromStopListResponse(): MsgRemoveTxFromStopListResponse {
  return {};
}

export const MsgRemoveTxFromStopListResponse: MessageFns<MsgRemoveTxFromStopListResponse> = {
  encode(_: MsgRemoveTxFromStopListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgRemoveTxFromStopListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgRemoveTxFromStopListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgRemoveTxFromStopListResponse {
    return {};
  },

  toJSON(_: MsgRemoveTxFromStopListResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgRemoveTxFromStopListResponse>, I>>(base?: I): MsgRemoveTxFromStopListResponse {
    return MsgRemoveTxFromStopListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgRemoveTxFromStopListResponse>, I>>(_: I): MsgRemoveTxFromStopListResponse {
    const message = createBaseMsgRemoveTxFromStopListResponse();
    return message;
  },
};

function createBaseMsgStartEpoch(): MsgStartEpoch {
  return { creator: "", epochId: 0, info: [], tssThreshold: 0, startTime: "0" };
}

export const MsgStartEpoch: MessageFns<MsgStartEpoch> = {
  encode(message: MsgStartEpoch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.epochId !== 0) {
      writer.uint32(16).uint32(message.epochId);
    }
    for (const v of message.info) {
      TSSInfo.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.tssThreshold !== 0) {
      writer.uint32(32).uint32(message.tssThreshold);
    }
    if (message.startTime !== "0") {
      writer.uint32(40).int64(message.startTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgStartEpoch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStartEpoch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info.push(TSSInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tssThreshold = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.startTime = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgStartEpoch {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
      info: globalThis.Array.isArray(object?.info) ? object.info.map((e: any) => TSSInfo.fromJSON(e)) : [],
      tssThreshold: isSet(object.tssThreshold)
        ? globalThis.Number(object.tssThreshold)
        : isSet(object.tss_threshold)
        ? globalThis.Number(object.tss_threshold)
        : 0,
      startTime: isSet(object.startTime)
        ? globalThis.String(object.startTime)
        : isSet(object.start_time)
        ? globalThis.String(object.start_time)
        : "0",
    };
  },

  toJSON(message: MsgStartEpoch): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    if (message.info?.length) {
      obj.info = message.info.map((e) => TSSInfo.toJSON(e));
    }
    if (message.tssThreshold !== 0) {
      obj.tssThreshold = Math.round(message.tssThreshold);
    }
    if (message.startTime !== "0") {
      obj.startTime = message.startTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgStartEpoch>, I>>(base?: I): MsgStartEpoch {
    return MsgStartEpoch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgStartEpoch>, I>>(object: I): MsgStartEpoch {
    const message = createBaseMsgStartEpoch();
    message.creator = object.creator ?? "";
    message.epochId = object.epochId ?? 0;
    message.info = object.info?.map((e) => TSSInfo.fromPartial(e)) || [];
    message.tssThreshold = object.tssThreshold ?? 0;
    message.startTime = object.startTime ?? "0";
    return message;
  },
};

function createBaseMsgStartEpochResponse(): MsgStartEpochResponse {
  return {};
}

export const MsgStartEpochResponse: MessageFns<MsgStartEpochResponse> = {
  encode(_: MsgStartEpochResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgStartEpochResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgStartEpochResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgStartEpochResponse {
    return {};
  },

  toJSON(_: MsgStartEpochResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgStartEpochResponse>, I>>(base?: I): MsgStartEpochResponse {
    return MsgStartEpochResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgStartEpochResponse>, I>>(_: I): MsgStartEpochResponse {
    const message = createBaseMsgStartEpochResponse();
    return message;
  },
};

function createBaseMsgSetEpochSignature(): MsgSetEpochSignature {
  return { creator: "", epochId: 0, epochChainSignatures: [], addresses: [] };
}

export const MsgSetEpochSignature: MessageFns<MsgSetEpochSignature> = {
  encode(message: MsgSetEpochSignature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.epochId !== 0) {
      writer.uint32(16).uint32(message.epochId);
    }
    for (const v of message.epochChainSignatures) {
      EpochChainSignatures.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.addresses) {
      EpochBridgeAddress.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetEpochSignature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetEpochSignature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.epochChainSignatures.push(EpochChainSignatures.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.addresses.push(EpochBridgeAddress.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSetEpochSignature {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
      epochChainSignatures: globalThis.Array.isArray(object?.epochChainSignatures)
        ? object.epochChainSignatures.map((e: any) => EpochChainSignatures.fromJSON(e))
        : globalThis.Array.isArray(object?.epoch_chain_signatures)
        ? object.epoch_chain_signatures.map((e: any) => EpochChainSignatures.fromJSON(e))
        : [],
      addresses: globalThis.Array.isArray(object?.addresses)
        ? object.addresses.map((e: any) => EpochBridgeAddress.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MsgSetEpochSignature): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    if (message.epochChainSignatures?.length) {
      obj.epochChainSignatures = message.epochChainSignatures.map((e) => EpochChainSignatures.toJSON(e));
    }
    if (message.addresses?.length) {
      obj.addresses = message.addresses.map((e) => EpochBridgeAddress.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetEpochSignature>, I>>(base?: I): MsgSetEpochSignature {
    return MsgSetEpochSignature.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetEpochSignature>, I>>(object: I): MsgSetEpochSignature {
    const message = createBaseMsgSetEpochSignature();
    message.creator = object.creator ?? "";
    message.epochId = object.epochId ?? 0;
    message.epochChainSignatures = object.epochChainSignatures?.map((e) => EpochChainSignatures.fromPartial(e)) || [];
    message.addresses = object.addresses?.map((e) => EpochBridgeAddress.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMsgSetEpochSignatureResponse(): MsgSetEpochSignatureResponse {
  return {};
}

export const MsgSetEpochSignatureResponse: MessageFns<MsgSetEpochSignatureResponse> = {
  encode(_: MsgSetEpochSignatureResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetEpochSignatureResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetEpochSignatureResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSetEpochSignatureResponse {
    return {};
  },

  toJSON(_: MsgSetEpochSignatureResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetEpochSignatureResponse>, I>>(base?: I): MsgSetEpochSignatureResponse {
    return MsgSetEpochSignatureResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetEpochSignatureResponse>, I>>(_: I): MsgSetEpochSignatureResponse {
    const message = createBaseMsgSetEpochSignatureResponse();
    return message;
  },
};

function createBaseMsgSetEpochPubKey(): MsgSetEpochPubKey {
  return { creator: "", pubkey: "", epochId: 0 };
}

export const MsgSetEpochPubKey: MessageFns<MsgSetEpochPubKey> = {
  encode(message: MsgSetEpochPubKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.pubkey !== "") {
      writer.uint32(18).string(message.pubkey);
    }
    if (message.epochId !== 0) {
      writer.uint32(24).uint32(message.epochId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetEpochPubKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetEpochPubKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pubkey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MsgSetEpochPubKey {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      pubkey: isSet(object.pubkey) ? globalThis.String(object.pubkey) : "",
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
    };
  },

  toJSON(message: MsgSetEpochPubKey): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.pubkey !== "") {
      obj.pubkey = message.pubkey;
    }
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetEpochPubKey>, I>>(base?: I): MsgSetEpochPubKey {
    return MsgSetEpochPubKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetEpochPubKey>, I>>(object: I): MsgSetEpochPubKey {
    const message = createBaseMsgSetEpochPubKey();
    message.creator = object.creator ?? "";
    message.pubkey = object.pubkey ?? "";
    message.epochId = object.epochId ?? 0;
    return message;
  },
};

function createBaseMsgSetEpochPubKeyResponse(): MsgSetEpochPubKeyResponse {
  return {};
}

export const MsgSetEpochPubKeyResponse: MessageFns<MsgSetEpochPubKeyResponse> = {
  encode(_: MsgSetEpochPubKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MsgSetEpochPubKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetEpochPubKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MsgSetEpochPubKeyResponse {
    return {};
  },

  toJSON(_: MsgSetEpochPubKeyResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MsgSetEpochPubKeyResponse>, I>>(base?: I): MsgSetEpochPubKeyResponse {
    return MsgSetEpochPubKeyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MsgSetEpochPubKeyResponse>, I>>(_: I): MsgSetEpochPubKeyResponse {
    const message = createBaseMsgSetEpochPubKeyResponse();
    return message;
  },
};

/** Msg defines the Msg service. */
export interface Msg {
  /** this line is used by starport scaffolding # proto/tx/rpc */
  SubmitTransactions(request: MsgSubmitTransactions): Promise<MsgSubmitTransactionsResponse>;
  RemoveTransaction(request: MsgRemoveTransaction): Promise<MsgRemoveTransactionResponse>;
  UpdateTransaction(request: MsgUpdateTransaction): Promise<MsgUpdateTransactionResponse>;
  InsertChain(request: MsgInsertChain): Promise<MsgInsertChainResponse>;
  DeleteChain(request: MsgDeleteChain): Promise<MsgDeleteChainResponse>;
  InsertToken(request: MsgInsertToken): Promise<MsgInsertTokenResponse>;
  UpdateToken(request: MsgUpdateToken): Promise<MsgUpdateTokenResponse>;
  DeleteToken(request: MsgDeleteToken): Promise<MsgDeleteTokenResponse>;
  AddTokenInfo(request: MsgAddTokenInfo): Promise<MsgAddTokenInfoResponse>;
  RemoveTokenInfo(request: MsgRemoveTokenInfo): Promise<MsgRemoveTokenInfoResponse>;
  SetParties(request: MsgSetParties): Promise<MsgSetPartiesResponse>;
  SetTssThreshold(request: MsgSetTssThreshold): Promise<MsgSetTssThresholdResponse>;
  SetReferral(request: MsgSetReferral): Promise<MsgSetReferralResponse>;
  RemoveReferral(request: MsgRemoveReferral): Promise<MsgRemoveReferralResponse>;
  SetReferralRewards(request: MsgSetReferralRewards): Promise<MsgSetReferralRewardsResponse>;
  RemoveReferralRewards(request: MsgRemoveReferralRewards): Promise<MsgRemoveReferralRewardsResponse>;
  AddTxToStopList(request: MsgAddTxToStopList): Promise<MsgAddTxToStopListResponse>;
  RemoveTxFromStopList(request: MsgRemoveTxFromStopList): Promise<MsgRemoveTxFromStopListResponse>;
  StartEpoch(request: MsgStartEpoch): Promise<MsgStartEpochResponse>;
  SetEpochSignature(request: MsgSetEpochSignature): Promise<MsgSetEpochSignatureResponse>;
  SetEpochPubKey(request: MsgSetEpochPubKey): Promise<MsgSetEpochPubKeyResponse>;
}

export const MsgServiceName = "core.bridge.Msg";
export class MsgClientImpl implements Msg {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || MsgServiceName;
    this.rpc = rpc;
    this.SubmitTransactions = this.SubmitTransactions.bind(this);
    this.RemoveTransaction = this.RemoveTransaction.bind(this);
    this.UpdateTransaction = this.UpdateTransaction.bind(this);
    this.InsertChain = this.InsertChain.bind(this);
    this.DeleteChain = this.DeleteChain.bind(this);
    this.InsertToken = this.InsertToken.bind(this);
    this.UpdateToken = this.UpdateToken.bind(this);
    this.DeleteToken = this.DeleteToken.bind(this);
    this.AddTokenInfo = this.AddTokenInfo.bind(this);
    this.RemoveTokenInfo = this.RemoveTokenInfo.bind(this);
    this.SetParties = this.SetParties.bind(this);
    this.SetTssThreshold = this.SetTssThreshold.bind(this);
    this.SetReferral = this.SetReferral.bind(this);
    this.RemoveReferral = this.RemoveReferral.bind(this);
    this.SetReferralRewards = this.SetReferralRewards.bind(this);
    this.RemoveReferralRewards = this.RemoveReferralRewards.bind(this);
    this.AddTxToStopList = this.AddTxToStopList.bind(this);
    this.RemoveTxFromStopList = this.RemoveTxFromStopList.bind(this);
    this.StartEpoch = this.StartEpoch.bind(this);
    this.SetEpochSignature = this.SetEpochSignature.bind(this);
    this.SetEpochPubKey = this.SetEpochPubKey.bind(this);
  }
  SubmitTransactions(request: MsgSubmitTransactions): Promise<MsgSubmitTransactionsResponse> {
    const data = MsgSubmitTransactions.encode(request).finish();
    const promise = this.rpc.request(this.service, "SubmitTransactions", data);
    return promise.then((data) => MsgSubmitTransactionsResponse.decode(new BinaryReader(data)));
  }

  RemoveTransaction(request: MsgRemoveTransaction): Promise<MsgRemoveTransactionResponse> {
    const data = MsgRemoveTransaction.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveTransaction", data);
    return promise.then((data) => MsgRemoveTransactionResponse.decode(new BinaryReader(data)));
  }

  UpdateTransaction(request: MsgUpdateTransaction): Promise<MsgUpdateTransactionResponse> {
    const data = MsgUpdateTransaction.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdateTransaction", data);
    return promise.then((data) => MsgUpdateTransactionResponse.decode(new BinaryReader(data)));
  }

  InsertChain(request: MsgInsertChain): Promise<MsgInsertChainResponse> {
    const data = MsgInsertChain.encode(request).finish();
    const promise = this.rpc.request(this.service, "InsertChain", data);
    return promise.then((data) => MsgInsertChainResponse.decode(new BinaryReader(data)));
  }

  DeleteChain(request: MsgDeleteChain): Promise<MsgDeleteChainResponse> {
    const data = MsgDeleteChain.encode(request).finish();
    const promise = this.rpc.request(this.service, "DeleteChain", data);
    return promise.then((data) => MsgDeleteChainResponse.decode(new BinaryReader(data)));
  }

  InsertToken(request: MsgInsertToken): Promise<MsgInsertTokenResponse> {
    const data = MsgInsertToken.encode(request).finish();
    const promise = this.rpc.request(this.service, "InsertToken", data);
    return promise.then((data) => MsgInsertTokenResponse.decode(new BinaryReader(data)));
  }

  UpdateToken(request: MsgUpdateToken): Promise<MsgUpdateTokenResponse> {
    const data = MsgUpdateToken.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdateToken", data);
    return promise.then((data) => MsgUpdateTokenResponse.decode(new BinaryReader(data)));
  }

  DeleteToken(request: MsgDeleteToken): Promise<MsgDeleteTokenResponse> {
    const data = MsgDeleteToken.encode(request).finish();
    const promise = this.rpc.request(this.service, "DeleteToken", data);
    return promise.then((data) => MsgDeleteTokenResponse.decode(new BinaryReader(data)));
  }

  AddTokenInfo(request: MsgAddTokenInfo): Promise<MsgAddTokenInfoResponse> {
    const data = MsgAddTokenInfo.encode(request).finish();
    const promise = this.rpc.request(this.service, "AddTokenInfo", data);
    return promise.then((data) => MsgAddTokenInfoResponse.decode(new BinaryReader(data)));
  }

  RemoveTokenInfo(request: MsgRemoveTokenInfo): Promise<MsgRemoveTokenInfoResponse> {
    const data = MsgRemoveTokenInfo.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveTokenInfo", data);
    return promise.then((data) => MsgRemoveTokenInfoResponse.decode(new BinaryReader(data)));
  }

  SetParties(request: MsgSetParties): Promise<MsgSetPartiesResponse> {
    const data = MsgSetParties.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetParties", data);
    return promise.then((data) => MsgSetPartiesResponse.decode(new BinaryReader(data)));
  }

  SetTssThreshold(request: MsgSetTssThreshold): Promise<MsgSetTssThresholdResponse> {
    const data = MsgSetTssThreshold.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetTssThreshold", data);
    return promise.then((data) => MsgSetTssThresholdResponse.decode(new BinaryReader(data)));
  }

  SetReferral(request: MsgSetReferral): Promise<MsgSetReferralResponse> {
    const data = MsgSetReferral.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetReferral", data);
    return promise.then((data) => MsgSetReferralResponse.decode(new BinaryReader(data)));
  }

  RemoveReferral(request: MsgRemoveReferral): Promise<MsgRemoveReferralResponse> {
    const data = MsgRemoveReferral.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveReferral", data);
    return promise.then((data) => MsgRemoveReferralResponse.decode(new BinaryReader(data)));
  }

  SetReferralRewards(request: MsgSetReferralRewards): Promise<MsgSetReferralRewardsResponse> {
    const data = MsgSetReferralRewards.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetReferralRewards", data);
    return promise.then((data) => MsgSetReferralRewardsResponse.decode(new BinaryReader(data)));
  }

  RemoveReferralRewards(request: MsgRemoveReferralRewards): Promise<MsgRemoveReferralRewardsResponse> {
    const data = MsgRemoveReferralRewards.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveReferralRewards", data);
    return promise.then((data) => MsgRemoveReferralRewardsResponse.decode(new BinaryReader(data)));
  }

  AddTxToStopList(request: MsgAddTxToStopList): Promise<MsgAddTxToStopListResponse> {
    const data = MsgAddTxToStopList.encode(request).finish();
    const promise = this.rpc.request(this.service, "AddTxToStopList", data);
    return promise.then((data) => MsgAddTxToStopListResponse.decode(new BinaryReader(data)));
  }

  RemoveTxFromStopList(request: MsgRemoveTxFromStopList): Promise<MsgRemoveTxFromStopListResponse> {
    const data = MsgRemoveTxFromStopList.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveTxFromStopList", data);
    return promise.then((data) => MsgRemoveTxFromStopListResponse.decode(new BinaryReader(data)));
  }

  StartEpoch(request: MsgStartEpoch): Promise<MsgStartEpochResponse> {
    const data = MsgStartEpoch.encode(request).finish();
    const promise = this.rpc.request(this.service, "StartEpoch", data);
    return promise.then((data) => MsgStartEpochResponse.decode(new BinaryReader(data)));
  }

  SetEpochSignature(request: MsgSetEpochSignature): Promise<MsgSetEpochSignatureResponse> {
    const data = MsgSetEpochSignature.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetEpochSignature", data);
    return promise.then((data) => MsgSetEpochSignatureResponse.decode(new BinaryReader(data)));
  }

  SetEpochPubKey(request: MsgSetEpochPubKey): Promise<MsgSetEpochPubKeyResponse> {
    const data = MsgSetEpochPubKey.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetEpochPubKey", data);
    return promise.then((data) => MsgSetEpochPubKeyResponse.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
